import React from 'react'
import { Background, Container, Main } from './auth-form-wrapper.style'

const AuthFormWrapper = ({ children }) => {
    return (
        <Background>
            <Container>
                <Main>
                    {children}
                </Main>
            </Container>
        </Background>
    )
}

export { AuthFormWrapper }
